import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitWeightResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitWeightResultInput;
}>;


export type SubmitWeightResultMutation = (
  { __typename: 'Mutation' }
  & { submitWeightResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'message' | 'field'>
    )>> }
  ) | (
    { __typename: 'SubmitWeightResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & WeightAssessmentResultFragment
    )> }
  ) }
);

export type WeightAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'role' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'BmpResult' } | { __typename: 'CardioRespResult' } | { __typename: 'FinSwimResult' } | { __typename: 'IpptResult' } | { __typename: 'ML360Result' } | { __typename: 'March20kmResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SocResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } | (
    { __typename: 'WeightResult' }
    & WeightAssessmentResultDataFragment
  ) }
);

export type WeightAssessmentResultDataFragment = (
  { __typename: 'WeightResult' }
  & Pick<SchemaTypes.WeightResult, 'weightKg'>
);

export const WeightAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment WeightAssessmentResultData on WeightResult {
  weightKg
}
    `;
export const WeightAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment WeightAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      role
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on WeightResult {
      ...WeightAssessmentResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const SubmitWeightResultDocument = /*#__PURE__*/ gql`
    mutation SubmitWeightResult($input: SubmitWeightResultInput!) {
  submitWeightResult(input: $input) {
    ... on SubmitWeightResultSuccessfulResponse {
      result {
        ...WeightAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        message
        field
      }
    }
  }
}
    ${WeightAssessmentResultFragmentDoc}
${WeightAssessmentResultDataFragmentDoc}`;
export type SubmitWeightResultMutationFn = Apollo.MutationFunction<SubmitWeightResultMutation, SubmitWeightResultMutationVariables>;

/**
 * __useSubmitWeightResultMutation__
 *
 * To run a mutation, you first call `useSubmitWeightResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitWeightResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitWeightResultMutation, { data, loading, error }] = useSubmitWeightResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitWeightResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitWeightResultMutation, SubmitWeightResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitWeightResultMutation, SubmitWeightResultMutationVariables>(SubmitWeightResultDocument, options);
      }
export type SubmitWeightResultMutationHookResult = ReturnType<typeof useSubmitWeightResultMutation>;
export type SubmitWeightResultMutationResult = Apollo.MutationResult<SubmitWeightResultMutation>;
export type SubmitWeightResultMutationOptions = Apollo.BaseMutationOptions<SubmitWeightResultMutation, SubmitWeightResultMutationVariables>;